<template>
  <TheMenuLayout>
    <BaseSectionHeader>
      Inscription à un stage
    </BaseSectionHeader>
    <v-form @submit.prevent="subscribeToInternship">
      <InternshipSignUp @internship-ids-changed="handleInternshipIdsChanged" />
      <BaseButton block color="primary" type="submit" :disabled="isButtonDisabled">
        S'inscrire
      </BaseButton>
    </v-form>
  </TheMenuLayout>
</template>

<script>
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import InternshipSignUp from '@/views/partials/InternshipSignUp.vue';
import { mapActions, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import InternshipApi from '../backend/InternshipApi';
import BaseButton from '../components/BaseButton.vue';

export default {
  name: 'NewInternship',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    InternshipSignUp,
    BaseButton,
  },
  data() {
    return {
      isButtonDisabled: true,
    };
  },
  computed: mapFields('authentication', ['form.internship_ids', 'form.session_id', 'form.chosen_faculty_id']),
  created() {
    this.fetchRegistrations();
  },
  methods: {
    ...mapMutations(['setAlert']),
    ...mapActions(['fetchRegistrations']),
    subscribeToInternship() {
      InternshipApi.create(this.internship_ids, this.session_id).then(() => {
        this.setAlert({
          text: 'Votre demande d\'inscription a bien été prise en compte et est en cours de validation.',
          color: 'success',
          show: true,
        });
        this.internship_ids = [];
        this.chosen_faculty_id = null;
        this.session_id = null;
      }).catch(() => {
        this.setAlert({
          text: 'Une erreur est survenue lors de l\'inscription à votre stage.',
          color: 'error',
          show: true,
        });
      });
    },
    handleInternshipIdsChanged(internshipIds) {
      this.isButtonDisabled = internshipIds.length === 0;
    },
  },
};
</script>
